module.exports = __webpack_public_path__ + "static/media/LTC-alt.fab61757.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/currency-icons/LTC-alt.svg
// module id = 582
// module chunks = 0